import React from 'react'

import st from './index.scss'

export default ({ ...props }) => <div {...props} className={st['loading']} />
